import { render, staticRenderFns } from "./create-lead-form.vue?vue&type=template&id=68c2bf5f&"
import script from "./create-lead-form.vue?vue&type=script&lang=js&"
export * from "./create-lead-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports